var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "设置库存",
            visible: _vm.dialogVisible,
            width: "50%",
            "before-close": _vm.handleClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { staticClass: "form-centent", attrs: { size: "small" } },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "tip" }, [_vm._v("当前库存")]),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: "",
                          value:
                            _vm.rowData && _vm.rowData.goodsSkuInventory
                              ? _vm.rowData.goodsSkuInventory
                              : "",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "col" }, [
                  _c("div", { staticClass: "tip" }, [_vm._v("库存调整为")]),
                  _c(
                    "div",
                    { staticClass: "value" },
                    [
                      _c("el-input", {
                        model: {
                          value: _vm.formIn.goodsSkuInventory,
                          callback: function ($$v) {
                            _vm.$set(_vm.formIn, "goodsSkuInventory", $$v)
                          },
                          expression: "formIn.goodsSkuInventory",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]),
            ]
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleClose } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.doUpdate()
                    },
                  },
                },
                [_vm._v("确认")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }